import { settingsApi } from "./settings.api";

export const {
  useGetSettingsByCompanyQuery,
  useLazyGetSettingsByCompanyQuery,
  useUpdateSettingsMutation,
  useUploadLogoSettingsByCompanyMutation,
  useGetSettingsRecipientsByCompanyQuery,
  useLazyGetSettingsRecipientsByCompanyQuery,
  usePostSettingsRecipientsByCompanyMutation,
  usePatchSettingsRecipientsByCompanyMutation,
  useGetMailSettingsByCompanyQuery,
  usePostMailSettingsByCompanyMutation,
  usePatchMailSettingsByCompanyMutation
} = settingsApi;
